const MOBILE_THRESHOLD_PX = 900;

/**
 * @returns {google.maps|null}
 */
export function getGoogleMapsApi() {
    return typeof window.google?.maps?.Map === 'function' ? window.google.maps : null;
}

export function arrayUnique(arr) {
    return arr.filter((val, idx, self) => {
        return self.indexOf(val) === idx;
    });
}

export function isValidLatLng(obj) {
    return obj &&
        typeof obj.lat === 'number' && typeof obj.lng === 'number' &&
        !isNaN(obj.lat) && !isNaN(obj.lng);
}

export function duplicateObject(obj, args = {}) {
    const { exclude } = Object.assign({}, { exclude: [], }, args);
    const q = {};
    for (let key of Object.keys(obj)) {
        if (!exclude.includes(key)) {
            q[key] = obj[key];
        }
    }
    return q;
}

export function isMobile() {
    return window.innerWidth <= MOBILE_THRESHOLD_PX;
}
